import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroBanner() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <section className="relative h-[210px] md:h-[300px] flex items-center overflow-hidden bg-star-black">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20atmospheric%20abstract%20space%20scene%20with%20deep%20cosmic%20nebula%20in%20dark%20indigo%20and%20charcoal%20tones%2C%20scattered%20subtle%20stars%20with%20soft%20warm%20golden%20light%20particles%20floating%20in%20the%20void%2C%20elegant%20and%20minimal%20composition%20with%20gradient%20from%20deep%20space%20black%20to%20subtle%20warm%20glow%20at%20the%20bottom%20edge%2C%20artistic%20cosmic%20wallpaper%20style%2C%20no%20text%20no%20people%2C%20ultra%20high%20quality%2C%20professional%20concept%20art&width=1920&height=800&seq=hero1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Search Bar */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <form
              onSubmit={handleSearch}
              className="flex items-center bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2.5 w-full max-w-md"
            >
              <i className="ri-search-line text-white/60 text-sm mr-3"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜尋遊戲名稱..."
                className="bg-transparent text-sm text-white placeholder:text-white/40 focus:outline-none flex-1"
              />
            </form>
            <a
              href="/login"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-white/20 transition-colors flex-shrink-0 cursor-pointer"
            >
              <i className="ri-user-line text-white text-sm md:text-base"></i>
            </a>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-3 tracking-tight">
            Steam Key Shop
          </h1>
          <p className="text-lg md:text-xl text-white/50 font-light mb-6">
            ☆ 販售商品僅限於台灣地區使用 ☆
          </p>
          <p className="text-sm md:text-base text-white/40 max-w-lg mx-auto mb-8 leading-relaxed">
            最超值的 Steam 遊戲序號都在這裡，每日精選折扣讓你省錢玩大作！
          </p>
          <a
            href="#products"
            className="inline-flex items-center gap-2 bg-white text-text-dark px-6 py-3 rounded-full text-sm font-medium hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
          >
            開始搶購
            <i className="ri-arrow-down-line text-xs"></i>
          </a>
        </div>
      </div>
    </section>
  );
}